import { motion } from "framer-motion";
import diff from '../assest/products/extra/diff.webp'

const points = [
  "Save up to 50% cost",
  "Corporate-grade testing",
  "Warranty + AMC support",
  "Fast delivery & GST billing",
  "Dedicated support team",
];

const WhyUsBlock = () => {
  return (
    <div className="grid md:grid-cols-2 gap-10 items-center mt-20">

      {/* 🔥 TEXT SIDE */}
      <motion.div
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >

        <h2 className="text-2xl md:text-4xl font-bold mb-6">
          Why Choose Us?
        </h2>

        {/* POINTS */}
        <div className="space-y-4">

          {points.map((item, i) => (

            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.03 }}
              className="flex items-center gap-4 bg-white p-4 rounded-xl shadow hover:shadow-lg transition"
            >

              {/* ICON */}
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-100 text-green-600 font-bold">
                ✓
              </div>

              {/* TEXT */}
              <p className="text-gray-700 text-sm md:text-base font-medium">
                {item}
              </p>

            </motion.div>

          ))}

        </div>

      </motion.div>

      {/* 🔥 IMAGE SIDE */}
      <motion.div
        initial={{ opacity: 0, x: 60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        whileHover={{ scale: 1.02 }}
        className="relative rounded-3xl overflow-hidden shadow-2xl"
      >

        {/* IMAGE */}
        <img
          src={diff}
          className="w-full h-[260px] md:h-[400px] object-cover"
        />

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>

        {/* TEXT OVER IMAGE */}
        <div className="absolute bottom-6 left-6 text-white">
          <h3 className="text-lg md:text-2xl font-bold">
            Trusted by Businesses
          </h3>
          <p className="text-sm opacity-80">
            Reliable IT solutions for modern companies
          </p>
        </div>

      </motion.div>

    </div>
  );
};

export default WhyUsBlock;